import ServiciosSociales from "./ServiciosSociales";

export default ServiciosSociales;
export { default as ServiceCard } from "./ServiceCard";
export { default as AdherentesList } from "./AdherentesList";
